import React from 'react';
import MenuContainer from './containers/MenuContainer';

export default props => <MenuContainer {...props} />;
